import React from 'react'
export default function StockPortfolio(){
     return(
        <div className='m-4'>
        <h2 className='mb-4 text-lg structure__main__subttl'>Stock Portfolio</h2>
        <p className='text-sm mb-12'>
         1 select stock<br/>
         2 set email, min, max<br/>
         3 receive notification<br/>
        </p>
        </div>
     )
}